import Icon, { IconProps } from './Icon';

import CheckIcon from '../../../assets/icons/check.svg?react';

const Check: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <CheckIcon />
    </Icon>
  );
};

export default Check;
